import React from 'react';
import Select from 'react-select';

function MultiNewSelect({
    className,
    isMulti,
    placeHolder,
    options,
    id,
    value,
    onChange,
    name,
    disabled,
    onFocus,
    isAddons, // <-- new prop
    ...restProps
}) {
    const handleFocus = onFocus || (() => {});

    const customStyles = isAddons
        ? {
             multiValue: (provided, state) => ({
                    ...provided,
                    backgroundColor: state.data.pph 
                    ? "#ffcccc"  // PPH items
                    : "#ccffcc", // Total price items
                    color: state.data.pph ? "#a50000" : "#006600",
                    fontWeight: 500
                }),
                multiValueLabel: (provided, state) => ({
                    ...provided,
                    color: state.data.pph ? "#a50000" : "#006600"
                }),
                multiValueRemove: (provided, state) => ({
                    ...provided,
                    color: state.data.pph ? "#a50000" : "#006600",
                    ':hover': {
                    backgroundColor: state.data.pph ? "#ff9999" : "#99ff99",
                    color: "#000"
                    }
                })
            }
        : {}; // No special styling for non-addons

    return (
        <Select
            isDisabled={disabled}
            value={value}
            onChange={onChange}
            options={options}
            isMulti={isMulti}
            name={name}
            placeholder={placeHolder}
            id={id}
            classNamePrefix="custom-select"
            onFocus={handleFocus}
            styles={customStyles}
            {...restProps}
        />
    );
}

export { MultiNewSelect };
